<!--
 * @Description: 未开票-平台发票（服务商端，订单类型：平台服务费/商务服务费/技术服务费）
 * @Date: 2025-06-11
-->
<template>
  <XrkTable
    ref="xrkTableRef"
    :getListAjax="getListAjax"
    :searchConfig="searchConfig"
    :tableConfig="tableConfig"
  ></XrkTable>
</template>
<script lang="tsx" setup>
import { ref, getCurrentInstance } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useInputColumn,
  BaseButton,
  useCreateModal
} from 'xrk-components';
import { formatter } from '@/utils';
import { notInvoicedList } from '@V/invoice/src/data-source/apis';
import type { NotInvoicedListParams } from '@V/invoice/src/data-source/types';
import { ORDER_TYPE } from '@constants/order';
import {
  projectNameSearch,
  userDefinedOrderNoSearch,
  userDefinedOrderTypeSearch,
  settlementNoSearch,
  projectServiceFeeOrderNoSearch
} from '@V/invoice/src/fields/searchs';
import {
  purchaserNameCol,
  projectNameCol,
  userDefinedOrderTypeCol,
  theSellerNameCol,
  receiveAtCol,
  settlementNoCol,
  projectServiceFeeOrderNoCol,
  orderNoCol
} from '@V/invoice/src/fields/columns';
import InvoiceOpenDialog from '../invoice-open-dialog';

/** 平台发票订单类型：平台服务费/商务服务费/技术服务费 */
const PLATFORM_ORDER_TYPES = [ORDER_TYPE[4], ORDER_TYPE[5], ORDER_TYPE[8]];

const xrkTableRef = ref();

const getListAjax = async (params: NotInvoicedListParams) => {
  return notInvoicedList(params);
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useInputColumn({
      prop: 'theSellerName',
      label: '销售方',
      config: { placeholder: '请输入', clearable: true }
    }),
    projectNameSearch(),
    settlementNoSearch(),
    projectServiceFeeOrderNoSearch(),
    userDefinedOrderNoSearch(),
    userDefinedOrderTypeSearch(PLATFORM_ORDER_TYPES)
  ],
  searchBtn: { show: true, text: '搜索' },
  resetBtn: { show: true, text: '重置' },
  otherComponents: [
    {
      render() {
        return (
          <BaseButton
            v-resource={[['未开票订单_申请开票']]}
            type="primary2"
            click={async () => {
              useCreateModal(
                InvoiceOpenDialog,
                {
                  tabKey: 3,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                },
                getCurrentInstance()
              );
            }}
          >
            申请开票
          </BaseButton>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({ type: 'index', label: '序号', width: '80px' }),
    purchaserNameCol(),
    projectNameCol(),
    settlementNoCol(),
    projectServiceFeeOrderNoCol(),
    orderNoCol(),
    userDefinedOrderTypeCol(),
    theSellerNameCol(),
    receiveAtCol(),
    useTableColumn({
      label: '金额（元）',
      prop: 'userDefinedPrice',
      width: '180px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    })
  ]
});
</script>
